module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Отказ",
      "to": "/moderate/section/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "section_name",
      "errors": _vm.errorBag.collect('category_name'),
      "cplaceholder": '(пример: Четене)'
    },
    model: {
      value: (_vm.section.name),
      callback: function($$v) {
        _vm.$set(_vm.section, "name", $$v)
      },
      expression: "section.name"
    }
  }), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "section_description",
      "errors": _vm.errorBag.collect('category_parent')
    },
    model: {
      value: (_vm.section.description),
      callback: function($$v) {
        _vm.$set(_vm.section, "description", $$v)
      },
      expression: "section.description"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "cat-badge",
    staticStyle: {
      "position": "absolute",
      "width": "40px",
      "height": "100%"
    },
    style: ({
      'background-color': _vm.section.color
    })
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "name": "section_color",
      "errors": _vm.errorBag.collect('section_color'),
      "values": _vm.$config.lists.sectionColors,
      "allow-other": true
    },
    model: {
      value: (_vm.section.color),
      callback: function($$v) {
        _vm.$set(_vm.section, "color", $$v)
      },
      expression: "section.color"
    }
  })], 1), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "name": "section_paid",
      "errors": _vm.errorBag.collect('section_paid'),
      "values": {
        '0': {
          text: 'Не'
        },
        '1': {
          text: 'Да'
        }
      }
    },
    model: {
      value: (_vm.section.paid),
      callback: function($$v) {
        _vm.$set(_vm.section, "paid", $$v)
      },
      expression: "section.paid"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bec6ce0!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/admin/SectionEdit.vue
// module id = 641
// module chunks = 1